import { RoleDropdown } from "../Types/Users";

export const RemoteAdFormat = [
  { Name: "None", Value: 0 },
  { Name: "Indeed", Value: 1 },
  { Name: "Monster", Value: 2 },
  { Name: "ZipRecruiter", Value: 3 },
  { Name: "LinkedIn", Value: 4 },
];

export const CRMRoles = [
  { name: "No CRM Access", value: 0 },
  { name: "CRM Access", value: 1 },
  { name: "CRM User Management", value: 2 },
] as RoleDropdown[];
